import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-79cd7c0b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "input-group-text",
    id: "basic-addon1"
};
const _hoisted_2 = ["value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Icon = _resolveComponent("Icon");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass('input-group input-group-sm mb-' + _ctx.mb)
    }, [
        _createElementVNode("span", _hoisted_1, [
            _createVNode(_component_Icon, {
                style: { "color": "#212529" },
                icon: ['fas', 'magnifying-glass']
            })
        ]),
        _createElementVNode("input", {
            type: "text",
            class: "form-control",
            value: _ctx.modelValue,
            onInput: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:modelValue', $event.target.value))),
            onKeydown: _cache[1] || (_cache[1] =
                //@ts-ignore
                (...args) => (_ctx.onKeypress && _ctx.onKeypress(...args)))
        }, null, 40, _hoisted_2)
    ], 2));
}
